var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-edit"},[(_vm.running)?_c('div',{staticClass:"position-absolute h-75 w-100"},[_c('spinner')],1):_vm._e(),_c('b-container',[_c('text-editor')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }